<mat-card>
    <mat-card-content class="newOrder">
        <div class="titleHead">
            <title-back [addTitle]="true" [Title]="'Lead Details: '" (back)="closeDetails()"> </title-back>
            <div fxLayout="row wrap" class="chipset">
                <span class="leadId">{{leadObj?.lead_number}} </span>
                <mat-chip class="sleek-chip secondary-chip">{{leadObj.invite.first_name}}
                    {{leadObj.invite.last_name}}</mat-chip>
                <mat-chip class="secondary-chip sleek-chip">{{leadObj.invite.company_name}}</mat-chip>
                <mat-chip class="secondary-chip sleek-chip" *ngIf="leadObj.lead_status">{{leadObj.lead_status_display}}</mat-chip>
                <!-- <span class="fullName"> {{leadObj.invite.first_name}} {{leadObj.invite.last_name}} </span> 
 <span class="companyName">  </span> -->
            </div>
        </div>
        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">USER DETAILS</span>
            <app-text-field [isEditable]="isEditable" [label]="'First Name*'" [name]="'first_name'"
                [(ngModel)]="leadObj.invite.first_name" [minlength]="3" [errors]="leadObj.error?.invite?.first_name">
            </app-text-field>

            <app-text-field [isEditable]="isEditable" [label]="'Last Name*'" [name]="'last_name'"
                [(ngModel)]="leadObj.invite.last_name" [minlength]="3" [errors]="leadObj.error?.invite?.last_name">
            </app-text-field>

            <app-text-field [isEditable]="false" [label]="'Email'" [name]="'email'" [(ngModel)]="leadObj.invite.email"
                [minlength]="5" [errors]="leadObj.error?.invite?.email">
            </app-text-field>

            <span *ngIf="leadObj.invite.is_otp_verified" class="verification"> <i class="flaticon-checked"></i>
                Verified</span>

            <app-phone-field [isEditable]="isEditable" [label]="'Phone*'" [(ngModel)]="leadObj.invite.phone"
                class="align-items-center" placeholder="XXXXXXXXXX"
                [errors]="leadObj.error?.invite?.phone"></app-phone-field>
        </div>
        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">COMPANY DETAILS</span>
            <app-text-field [isEditable]="false" [label]="'Company Name*'" [name]="'company_name'"
                [(ngModel)]="leadObj.invite.company_name" [errors]="leadObj.error?.invite?.company_name">
            </app-text-field>

            <app-mat-auto-search [isEditable]="false" [label]="'Country*'" [name]="'country'"
                [ngModel]="leadObj.invite.country" (ngModelChange)="filterStates($event)" [listUrl]="country_url"
                [setSearchValue]="false" [idField]="null" [displayField]="'name'"
                [errors]="leadObj.error?.invite?.country">
            </app-mat-auto-search>

            <app-mat-auto-search [label]="'State*'" [isEditable]="false" [name]="'state'"
                [ngModel]="leadObj.invite.state" [idField]="null" [setSearchValue]="false" [displayField]="'name'"
                [listUrl]="state_url" [errors]="leadObj.error?.invite?.state">
            </app-mat-auto-search>

            <app-text-field [isEditable]="false" [label]="'Address*'" [name]="'address'"
                [(ngModel)]="leadObj.invite.address" [isMultiline]="true" [minlength]="5"
                [errors]="leadObj.error?.invite?.address">
            </app-text-field>
        </div>
        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">REQUIREMENT DETAILS</span>
            <app-select-field [isEditable]="false" [label]="'Service Type'" [name]="'request_type'"
                [(ngModel)]="leadObj.request_type" [idField]="null" [displayField]="'name_display'"
                [options]="requestTypeList?.results" [errors]="leadObj.error?.request_type">
            </app-select-field>

            <app-mat-auto-search [label]="'Position*'" [isEditable]="isEditable" [name]="'transaction_type'"
                [(ngModel)]="leadObj.transaction_type" [idField]="null" [setSearchValue]="false" [displayField]="'value'"
                [listUrl]="transaction_type_url+leadObj.request_type?.dev_name"
                [errors]="leadObj.error?.transaction_type">
            </app-mat-auto-search>
            <div fxLayout="column" class="adminBox">
                <span class="boxTitle">Equipment <button mat-raised-button class="sleekBtn" [class.Save]="isEditable"
                        *ngIf="leadObj.request_type?.dev_name == 'lease'" (click)="addRequirements()"
                        [matTooltipDisabled]="!isEditable" matTooltip="Add more requirement" matTooltipPosition="left"
                        matTooltipHideDelay="0" [disabled]="!isEditable">Add</button>
                </span>
                <div class="leaseRequest">
                    <div class="leasebox">
                        <div class="inputs" *ngFor="let requirement of leadObj.requirements, let i=index">
                            <!-- Quantity -->
                            <div fxFlex="30" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Quantity*</span>
                                </div>
                                <app-number-field [isEditable]="isEditable" [containerNum]="true"
                                    [(ngModel)]="leadObj.requirements[i].quantity" [name]="'quantity'+i" [minValue]="1"
                                    [maxValue]="9999" [maxlength]="4" [noDecimal]="true"
                                    [errors]="leadObj.error?.requirements?.length ? leadObj.error?.requirements[i]?.quantity : ['']">
                                </app-number-field>
                            </div>

                            <!-- Container Size Type -->
                            <div fxFlex="30" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Container Type*</span>
                                </div>
                                <app-mat-auto-search [isEditable]="isEditable" class="containerType"
                                    [(ngModel)]="leadObj.requirements[i].container_size_type"
                                    [errors]="leadObj.error?.requirements?.length ? leadObj.error?.requirements[i]?.container_size_type : ['']"
                                    [idField]="null" displayField='display_name' [trim]="true" [clearable]="true"
                                    [listUrl]="container_size_type_url"></app-mat-auto-search>
                            </div>

                            <!-- Container Condition -->
                            <div fxFlex="30" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Condition*</span>
                                </div>
                                <app-mat-auto-search [isEditable]="isEditable"
                                    [(ngModel)]="leadObj.requirements[i].condition"
                                    [errors]="leadObj.error?.requirements?.length ? leadObj.error?.requirements[i]?.condition : ['']"
                                    [idField]="null" [displayField]="'value'" [name]="'condition'+i"
                                    [options]="containerConditionList?.results" [clearable]="false" [trim]="true"
                                    [searchable]="false"></app-mat-auto-search>
                            </div>

                            <!-- Leasing period -->
                            <ng-container *ngIf="leadObj.request_type?.dev_name == 'lease'">
                                <div fxFlex="30" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Leasing period (Days)*</span><i MatSuffix
                                            matTooltip="Enter the leasing period, for which you want to lease the container."
                                            matTooltipPosition="right" class="flaticon-message"></i>
                                    </div>
                                    <app-number-field [isEditable]="isEditable" [noDecimal]="true"
                                        [(ngModel)]="leadObj.requirements[i].leasing_period_days"
                                        [name]="'leasingDays'+i" [minValue]="0" [maxValue]="99999" [maxlength]="5"
                                        [errors]="leadObj.error?.requirements?.length ? leadObj.error?.requirements[i]?.leasing_period_days : ['']">
                                    </app-number-field>
                                </div>

                                <!-- Per Diem -->
                                <div fxFlex="30" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>Per Diem Charge</span>
                                    </div>
                                    <app-new-money-field fxLayout="column" [isEditable]="isEditable" [minValue]="0"
                                        [(amount)]="leadObj.requirements[i].per_diem"
                                        [(currency)]="leadObj.requirements[i].per_diem_currency"
                                        [errors]="leadObj.error?.requirements?.length ? leadObj.error?.requirements[i]?.per_diem : ['']"></app-new-money-field>
                                </div>
                            </ng-container>

                            <div class="actionBtn1">
                                <i class="flaticon-delete" [class.delete]="isEditable"
                                    [matTooltipDisabled]="!isEditable" (click)="removeRequirements(i)"
                                    matTooltip="Delete" matTooltipPosition="below"
                                    *ngIf="leadObj.requirements.length>1"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="column" class="detailBox">
            <span class="boxTitle">LOCATION DETAILS</span>
            <div class="portSelection">
                <span>{{superLocationSourceLabel}}</span>
                <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="leadObj.pol_list" [idField]="null"
                    [displayField]="'name_display'" [trim]="true" [multiple]="true" [defaultChip]="false"
                    [clearable]="true" [listUrl]="port_url" [name]="'pols'" [errors]="leadObj.error?.pol_list">
                </app-mat-auto-search>
            </div>
            <ng-container *ngIf="!(leadObj?.request_type?.dev_name=='buy_sell')">
                <div class="portSelection">
                    <span>{{superLocationDestinationLabel}}</span>
                    <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="leadObj.pod_list" [idField]="null"
                        displayField='name_display' [trim]="true" [multiple]="true" [defaultChip]="false"
                        [clearable]="true" [listUrl]="port_url" [name]="'pods'" [errors]="leadObj.error?.pod_list">
                    </app-mat-auto-search>
                </div>
            </ng-container>
        </div>
        <div fxFlex="100" class="adminBox">
            <span class="boxTitle">ADMIN-USE ONLY</span>
            <div class="subBox">
                <span class="subBoxTitle">Administrative Action</span>
                <app-select-field [isEditable]="isEditable" [label]="'Assign Role*'" [name]="'role'"
                    [(ngModel)]="leadObj.invite.role" [idField]="null" [displayField]="'name'" [tooltipIcon]="true"
                    [delay]="0"
                    [tooltipName]="'Choose the role of the user. Admins have more privileges than employees, so select accordingly.'"
                    [options]="profileRoleList?.results" [errors]="leadObj.error?.invite?.role">
                </app-select-field>

                <app-mat-auto-search [isEditable]="isEditable" [label]="'Map Company*'" [name]="'company'"
                    [ngModel]="leadObj.invite.company" (ngModelChange)="getCompanyDetails($event)" [idField]="null"
                    [displayField]="'legal_name'" [listUrl]="company_url" [setSearchValue]="true"
                    [labelItemTemplate]="companySelectedItem" [itemTemplate]="companyItem" [tooltipIcon]="true"
                    [delay]="0"
                    [tooltipName]="'Choose the company associated with this lead. This helps establish a clear link between lead and their corresponding company.'"
                    [errors]="leadObj.error?.invite?.company">
                </app-mat-auto-search>

                <app-text-field [isEditable]="false" [label]="'Lead Source'" [name]="'lead_source'"
                    [(ngModel)]="leadObj.request_source" [minlength]="5" [errors]="leadObj.error?.request_source"
                    [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Enter the origin or source of the lead. This helps in tracking and analyzing where our leads are coming from.'">
                </app-text-field>
                <!-- <app-mat-auto-search [isEditable]="false" [label]="'Lead Source*'" [name]="'lead_source'"
                    [(ngModel)]="leadObj.request_source" [displayField]="'display_name'"
                    [options]="resourceOptions?.actions?.POST?.request_source?.choices" [idField]="'value'" [minlength]="5"
                    [tooltipIcon]="true" [delay]="0" [errors]="leadObj.error.request_source"
                    [tooltipName]="'Enter the origin or source of the lead. This helps in tracking and analyzing where our leads are coming from.'">
                </app-mat-auto-search> -->
                <app-select-field [isEditable]="isEditable" [label]="'Lead Status*'" [name]="'lead_status'"
                    [tooltipIcon]="true" [delay]="0"
                    [tooltipName]="'Choose between [Approve] if the leads details are accurate and meet your criteria or [Reject] if the details are inaccurate or does not qualify for our services.'"
                    [ngModel]="leadObj.lead_status" (ngModelChange)="setRemarks($event)" [idField]="'value'"
                    [displayField]="'display_name'" [options]="leadExternalInviteOptions"
                    [errors]="leadObj.error?.lead_status">
                </app-select-field>
                <ng-container *ngIf="isApproveLogin">
                    <app-select-field [isEditable]="isEditable" [label]="'Approve Login*'" [name]="'login_status'"
                        [tooltipIcon]="true" [delay]="0"
                        [tooltipName]="'Select whether this lead should be granted access(Yes) or not(Not) to ARCON system. Approval grants login privileges.'"
                        [(ngModel)]="leadObj.invite.is_login_approved" [idField]="'id'" [displayField]="'value'"
                        [options]="leadObj.invite.loginApprovalList" [errors]="leadObj.error?.invite?.is_login_approved">
                    </app-select-field>
                </ng-container>

                
                <div *ngIf="leadObj.invite.approval_status == 'company_unassigned' || leadObj.invite.approval_status == 'pending'"
                    class="align-items-center">
                    <div class="inputTitle">
                        <span>Skip Verification*</span><i MatSuffix
                            matTooltip="Company Admin user would not have to verify the user if you choose to skip verification. "
                            matTooltipPosition="right" class="flaticon-message"></i>
                    </div>
                    <mat-button-toggle-group [(ngModel)]="leadObj.invite.bypass_external_verification"
                        name="bypass_verification" [disabled]="!isEditable">
                        <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="false">No</mat-button-toggle>
                    </mat-button-toggle-group>
                    <ul *ngIf="leadObj.error?.invite?.bypass_external_verification?.length" class="errorList">
                        <li *ngFor="let item of leadObj.error?.invite?.bypass_external_verification" class="error">
                            {{item}}</li>
                    </ul>
                </div>

                <!-- [options]="leadObj.leadApprovalList" -->
                <ng-container *ngIf="leadObj.lead_status=='rejected'">
                    <app-select-field [isEditable]="isEditable" [label]="'Decline Reason*'" [name]="'rejection_reason'"
                        [ngModel]="leadObj.rejection_reason" (ngModelChange)="setRejection($event)" [idField]="null"
                        [displayField]="'value'" [tooltipIcon]="true" [delay]="0"
                        tooltipName="'If you're rejecting the lead, select the reason for the rejection'"
                        [options]="rejectionReasonList?.results" [errors]="leadObj.error?.rejection_reason">
                    </app-select-field>
                </ng-container>

                <app-text-field [isEditable]="isEditable" [label]="'Remarks*'" [name]="'remarks'"
                    [(ngModel)]="leadObj.remarks" [tooltipIcon]="true" [delay]="0" [maxlength]="500"
                    [tooltipName]="'Add any additional comments, notes or observations related to this lead verification process.'"
                    [minlength]="5" [isMultiline]="true" [errors]="leadObj.error?.remarks">
                </app-text-field>

                <div
                    *ngIf="leadObj.invite.approval_status != 'company_unassigned'">
                    <!-- && leadObj.invite.approval_status != 'pending' -->
                    <label>{{ leadObj.lead_status.value === 'rejected' ? 'Rejected By' : 'Approved By' }}</label>
                    <span>{{leadObj.invite.approved_rejected_by?.first_name}}
                        {{leadObj.invite.approved_rejected_by?.last_name}} at {{leadObj.invite.approved_rejected_at |
                        date:'dd MMM, yyyy hh:mm a'}}</span>
                </div>
                <!-- <span *ngIf="!isEditable">{{leadObj.invite.approved_rejected_at | date:'dd MMM, yyyy'}}</span> -->
            </div>
            <div class="subBox">
                <span class="subBoxTitle">Login Details</span>
                <div><label>Lead Creation Date</label>
                    <span>{{leadObj.created_at | date:'dd MMM, yyyy'}}</span>
                </div>
                <div><label>Location</label>
                    <span>{{leadObj.invite.client_location}}</span>
                </div>
                <div><label>Device</label>
                    <span>{{leadObj.invite.client_browser}} {{leadObj.invite.client_device}}</span>
                </div>
                <div><label>OTP Verification</label>
                    <span>{{leadObj.invite.otp_verified_at | date : 'dd MMM, yyyy hh:mm a'}}</span>
                </div>
            </div>
        </div>
        <div class="actionBtn">
            <button *ngIf="isEditable" mat-raised-button class="addBtn" (click)="submitLeadForApproval()">Save</button>
        </div>
    </mat-card-content>
</mat-card>

<ng-template #companyItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.name }}
        </span>
        <span class="email">
            {{item?.primary_branch?.address}}
        </span>
    </div>
</ng-template>

<ng-template #companySelectedItem let-item>
    {{ item?.name }}
</ng-template>